import { DateTime } from 'luxon';

const holidays = require( '@/data/bank-holidays.json' );
const months = require( '@/data/months.json' );

export default class Payment {
    /**
     * Fetch the latest payment date
     * @return {DateTime}
     */
    static date() {
        return getPaymentDate( DateTime.now().set( {
            day        : 7,
            hours      : 0,
            minutes    : 0,
            seconds    : 0,
            millisecond: 0
        } ) );
    }
}

/**
 * Recursively refine a date through a set of conditions to find the next payment date.
 * Filters out dates that occur on months where no payments occur
 * "Payments are made on the 7th of each month (or the closest working/banking day before the 7th)"
 * @param {DateTime} date - A potential candidate for the payment date
 * @return {DateTime}
 */
function getPaymentDate( date ) {
    if ( ! months.includes( date.month ) ) {
        return getPaymentDate( date.set( { day: 7 } ).plus( { month: 1 } ) );
    }

    if ( holidays.scotland.events.some( e => e.date === date.toISODate() ) ) {
        return getPaymentDate( date.minus( { day: 1 } ) );
    }

    if ( date.weekday === 6 ) {
        return getPaymentDate( date.minus( { day: 1 } ) );
    }

    if ( date.weekday === 7 ) {
        return getPaymentDate( date.minus( { day: 2 } ) );
    }

    if ( date < DateTime.now().minus( { day: 1 } ) ) {
        return getPaymentDate( date.set( { day: 7 } ).plus( { month: 1 } ) );
    }

    return date;
}
